module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.buttonStyle ? 'label' : 'div', {
    tag: "div",
    class: [(_vm.buttonStyle ? 'btn btn-' + _vm.typeColor : 'radio ' + _vm.typeColor), {
      active: _vm.active,
      disabled: _vm.disabled,
      readonly: _vm.readonly
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [(_vm.buttonStyle) ? [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.check),
      expression: "check"
    }],
    ref: "input",
    attrs: {
      "type": "radio",
      "autocomplete": "off",
      "name": _vm.name,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.selectedValue,
      "checked": _vm._q(_vm.check, _vm.selectedValue)
    },
    on: {
      "__c": function($event) {
        _vm.check = _vm.selectedValue
      }
    }
  }), _vm._v(" "), _vm._t("default")] : _c('label', {
    staticClass: "open"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check),
      expression: "check"
    }],
    ref: "input",
    attrs: {
      "type": "radio",
      "autocomplete": "off",
      "name": _vm.name,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.selectedValue,
      "checked": _vm._q(_vm.check, _vm.selectedValue)
    },
    on: {
      "__c": function($event) {
        _vm.check = _vm.selectedValue
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon dropdown-toggle",
    class: [_vm.active ? 'btn-' + _vm.typeColor : '', {
      bg: _vm.typeColor === 'default'
    }]
  }), _vm._v(" "), (_vm.active && _vm.typeColor === 'default') ? _c('span', {
    staticClass: "icon"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5ceac9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5ceac9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Radio.vue
// module id = 152
// module chunks = 0